import remindCreditApp from './remindCreditApp.js';
import remindTestDrive from './remindTestDrive.js';

// Shared logic for wallet notifications used by both WalletHeaderPopover and WalletNotification
// This helps avoid code duplication while maintaining both components during migration

// eslint-disable-next-line consistent-return
const getDealReminders = (dealDetails, messages) => {
  const dealReminders = [];
  const panel = 'activeDeals';
  const dealHasCreditAppReminding = remindCreditApp(dealDetails);
  if (dealHasCreditAppReminding) {
    dealReminders.push({
      dealId: dealHasCreditAppReminding.id,
      updateKey: 'creditAppNotified'
    });
  }
  const dealHasTestDriveReminding = remindTestDrive(dealDetails);
  if (dealHasTestDriveReminding) {
    dealReminders.push({
      dealId: dealHasTestDriveReminding.id,
      updateKey: 'testDriveNotified'
    });
  }
  if (dealReminders?.length > 0) {
    if (dealHasCreditAppReminding && dealHasTestDriveReminding) {
      return {
        message: messages.testDriveAndCreditApp,
        panel,
        label: 'View deal dashboard',
        dealReminders,
        deal: dealHasCreditAppReminding
      };
    }
    if (dealHasCreditAppReminding) {
      return {
        message: messages.creditApp,
        panel,
        label: 'Apply for credit',
        dealReminders,
        deal: dealHasCreditAppReminding
      };
    }
    if (dealHasTestDriveReminding) {
      return {
        message: messages.testDrive,
        panel,
        label: 'Schedule a test drive',
        dealReminders,
        deal: dealHasTestDriveReminding
      };
    }
    return {};
  }
};

/**
 * Shared function to generate wallet notification/popover data
 * Used by both WalletHeaderPopover and WalletNotification components
 *
 * @param {boolean} hasNewTradeIn - Whether user has a new trade-in
 * @param {object} dealNotifications - Object containing notification counts and flags
 * @param {object} dealDetails - Deal details keyed by deal ID
 * @param {object} messages - Messages object (popoverMessages or notificationMessages)
 * @returns {object} Notification data object
 */
const getWalletNotificationData = (hasNewTradeIn, dealNotifications, dealDetails, messages) => {
  const panel = 'activeDeals';

  // tradeIn only
  if (hasNewTradeIn && !dealNotifications?.total) {
    return {
      message: messages.tradeInOnly,
      panel: 'valuationHistory'
    };
  }

  // deals and tradeIn notifications
  if (hasNewTradeIn && dealNotifications?.total) {
    return {
      message: messages.dealAndTradeIn,
      panel: ''
    }; // ?
  }
  if (!hasNewTradeIn && dealNotifications) {
    const notificationKeys = Object.keys(dealNotifications);
    // NOTE: Gets any keys that have a true value
    const updatedNotifications = notificationKeys.filter(key => key !== 'total' && dealNotifications[key]);

    // multiple deal types
    if (updatedNotifications.length > 1) {
      return {
        message: messages.dealsAndNoTradeIn,
        panel
      };
    }
    if (updatedNotifications.length === 1 && updatedNotifications[0]) {
      return {
        message: messages[updatedNotifications[0]],
        panel
      };
    }
    const dealReminders = getDealReminders(dealDetails, messages);
    if (dealReminders) {
      return dealReminders;
    }
  }
  return {};
};
export { getDealReminders, getWalletNotificationData };
